import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "popup-main"
};
const _hoisted_2 = {
  class: "popup-content"
};
const _hoisted_3 = {
  class: "type-list"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "type-item-title"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "dividing-line"
}, null, -1);
const _hoisted_7 = {
  class: "additional-text flex"
};
const _hoisted_8 = {
  class: "detail-wrap"
};
const _hoisted_9 = {
  key: 0,
  class: "download-banner-wrap"
};
const _hoisted_10 = {
  key: 1,
  class: "download-banner-wrap"
};
const _hoisted_11 = {
  class: "download-banner-content flex"
};
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, "What is the GCash", -1);
const _hoisted_13 = {
  key: 2,
  class: "coupon-list"
};
const _hoisted_14 = {
  class: "input-row"
};
const _hoisted_15 = {
  class: "input-label"
};
const _hoisted_16 = {
  class: "input-box"
};
const _hoisted_17 = {
  key: 0,
  class: "deposite-bonus"
};
const _hoisted_18 = {
  key: 1,
  class: "deposite-bonus"
};
const _hoisted_19 = {
  key: 3,
  class: "bank-list"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = ["src"];
const _hoisted_22 = {
  key: 4,
  class: "price-list"
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = {
  class: "price-item-title"
};
const _hoisted_25 = {
  key: 0,
  class: "bonus-wrap"
};
const _hoisted_26 = {
  class: "bonus-value"
};
import { ref, watch, computed, onMounted } from 'vue';
import { debounce } from 'lodash-es';
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useHelpTool } from '@/hooks';
import { useUserStore, usePopupStore } from '@/store';
import PopupHeader from '@/components/Common/PopupHeader';
import Record from './DepositRecord';
import SignUpBonus from './SignUpBonus';
import Exchange from './Exchange';
import Coupon from './Coupon';
import { queryDepositProduct, queryDepositBank, queryDepositAmount, queryCoupon, preCreateDeposit, createDeposit } from '@/api';
const MAYA_DOWNLOAD_URL = 'https://play.google.com/store/apps/details?id=com.paymaya&hl=en';
const GCASH_YOUTUBE = 'https://youtu.be/oVX_XWtalzM';
export default {
  __name: 'Deposit',
  emits: ['onClose'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const {
      openBrowser
    } = useHelpTool();
    const {
      t
    } = useI18n();
    const userStore = useUserStore();
    const popupStore = usePopupStore();
    const {
      initData
    } = storeToRefs(popupStore);
    const selfRef = ref(null);
    const showRecord = ref(false);
    const typeList = ref([]);
    const activeType = ref(null);
    const bankList = ref([]);
    const activeBank = ref(null);
    const priceList = ref([]);
    const amount = ref(null);
    const activeAmount = ref(null);
    const couponList = ref([]);
    const activeCoupon = ref(null);
    const depositReward = ref(0);
    const confirmDisabled = computed(() => {
      var _activeType$value;
      if (((_activeType$value = activeType.value) === null || _activeType$value === void 0 ? void 0 : _activeType$value.channel) === 'bank') {
        var _activeType$value2, _activeType$value3, _activeType$value4;
        return !((_activeType$value2 = activeType.value) !== null && _activeType$value2 !== void 0 && _activeType$value2.product) || !activeBank.value || amount.value < ((_activeType$value3 = activeType.value) === null || _activeType$value3 === void 0 ? void 0 : _activeType$value3.lowLimit) || amount.value > ((_activeType$value4 = activeType.value) === null || _activeType$value4 === void 0 ? void 0 : _activeType$value4.upLimit);
      } else {
        var _activeType$value5, _activeType$value6, _activeType$value7;
        return !((_activeType$value5 = activeType.value) !== null && _activeType$value5 !== void 0 && _activeType$value5.product) || amount.value < ((_activeType$value6 = activeType.value) === null || _activeType$value6 === void 0 ? void 0 : _activeType$value6.lowLimit) || amount.value > ((_activeType$value7 = activeType.value) === null || _activeType$value7 === void 0 ? void 0 : _activeType$value7.upLimit);
      }
    });
    watch(activeType, (newValue, oldValue) => {
      priceList.value = [];
      if (newValue && newValue.product) {
        fetchDepositAmount();
        fetchCoupon();
        if (newValue.channel === 'bank') {
          fetchDepositBank();
        }
      }
    });
    watch(amount, (newValue, oldValue) => {
      activeAmount.value = null;
      if (newValue > 0) {
        priceList.value.map(item => {
          if (item.amount === Number(newValue)) {
            activeAmount.value = item;
          }
        });
        if (activeCoupon.value) {
          doPreDepositDebounce();
        }
      }
    });
    onMounted(() => {
      fetchDepositProduct();
    });
    const fetchDepositProduct = () => {
      queryDepositProduct().then(res => {
        typeList.value = res.data || [];
        let signUpBonusType = {
          type: 'signUpBonus',
          productName: 'Sign Up Bonus',
          channel: 'singUpBonus'
        };
        let exchangeType = {
          type: 'exchange',
          productName: 'Exchange',
          channel: 'exchange'
        };
        if (!userStore.hasSignUp) {
          typeList.value.unshift(signUpBonusType);
        }
        typeList.value.push(exchangeType);
        if (typeList.value.length > 0) {
          let initActiveType = typeList.value[0];
          if (initData.value) {
            const {
              type,
              product
            } = initData.value;
            let initTypeList = typeList.value.filter(item => {
              let flag = true;
              type && (flag = flag && item.type === type);
              product && (flag = flag && item.product === product);
              return flag;
            });
            if (initTypeList.length > 0) {
              initActiveType = initTypeList[0];
            }
          }
          activeType.value = initActiveType;
        }
      });
    };
    const fetchDepositBank = () => {
      queryDepositBank().then(res => {
        bankList.value = res.data || [];
        activeBank.value = null;
      });
    };
    const fetchDepositAmount = () => {
      queryDepositAmount({
        product: activeType.value.product
      }).then(res => {
        priceList.value = res.data || [];
      });
    };
    const fetchCoupon = () => {
      queryCoupon().then(res => {
        couponList.value = res.data || [];
        activeCoupon.value = null;
      });
    };
    const clickCoupon = item => {
      if (activeCoupon.value == item) {
        activeCoupon.value = null;
      } else {
        activeCoupon.value = item;
        if (amount.value > 0) {
          doPreDeposit();
        }
      }
    };
    const doPreDeposit = () => {
      var _activeCoupon$value, _activeBank$value;
      preCreateDeposit({
        product: activeType.value.product,
        amount: amount.value,
        couponCode: (_activeCoupon$value = activeCoupon.value) === null || _activeCoupon$value === void 0 ? void 0 : _activeCoupon$value.code,
        bank: activeType.value.channel === 'bank' ? (_activeBank$value = activeBank.value) === null || _activeBank$value === void 0 ? void 0 : _activeBank$value.bank : undefined
      }).then(res => {
        var _res$data;
        depositReward.value = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.reward;
      });
    };
    const doPreDepositDebounce = debounce(() => {
      if (amount.value) {
        doPreDeposit();
      }
    }, 500);
    const doDeposit = () => {
      var _activeCoupon$value2, _activeBank$value2;
      createDeposit({
        product: activeType.value.product,
        amount: amount.value,
        couponCode: (_activeCoupon$value2 = activeCoupon.value) === null || _activeCoupon$value2 === void 0 ? void 0 : _activeCoupon$value2.code,
        bank: activeType.value.channel === 'bank' ? (_activeBank$value2 = activeBank.value) === null || _activeBank$value2 === void 0 ? void 0 : _activeBank$value2.bank : undefined
      }).then(res => {
        if (res.data) {
          openBrowser(res.data, {
            message: t('msg.openDeposit'),
            showAlert: true
          });
          amount.value = '';
          activeCoupon.value = null;
          fetchCoupon();
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_popup = _resolveComponent("van-popup");
      const _directive_audio = _resolveDirective("audio");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        ref_key: "selfRef",
        ref: selfRef,
        class: "deposit-popup"
      }, [_createVNode(_component_van_popup, {
        class: "full-page",
        show: true,
        "close-on-click-overlay": false,
        "lock-scroll": false
      }, {
        default: _withCtx(() => {
          var _activeType$value8, _activeType$value9, _activeType$value10, _activeType$value11, _activeType$value12, _activeType$value13, _activeAmount$value, _activeAmount$value2, _activeType$value14;
          return [_createElementVNode("div", _hoisted_1, [_createVNode(_unref(PopupHeader), {
            recordIcon: true,
            onClickRecord: _cache[0] || (_cache[0] = $event => showRecord.value = true),
            onOnClose: _cache[1] || (_cache[1] = $event => emit('onClose'))
          }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeList.value, item => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(`type-item ${activeType.value === item ? 'active' : ''}`),
              key: item.product,
              onClick: $event => activeType.value = item
            }, [_createElementVNode("div", _hoisted_5, _toDisplayString(item.productName), 1), _hoisted_6, item.reward && item.reward.pointsProportionally ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(`additional-wrap ${item.isHot ? 'hot' : ''}`)
            }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, "+" + _toDisplayString(item.reward.pointsProportionally) + "%", 1), _createVNode(_component_van_image, {
              class: "additional-img",
              src: require('@/assets/img/finance/points.png')
            }, null, 8, ["src"])])], 2)) : _createCommentVNode("", true)], 10, _hoisted_4)), [[_directive_audio]]);
          }), 128))]), _createElementVNode("div", _hoisted_8, [((_activeType$value8 = activeType.value) === null || _activeType$value8 === void 0 ? void 0 : _activeType$value8.type) === 'exchange' ? (_openBlock(), _createBlock(_unref(Exchange), {
            key: 0
          })) : ((_activeType$value9 = activeType.value) === null || _activeType$value9 === void 0 ? void 0 : _activeType$value9.type) === 'signUpBonus' ? (_openBlock(), _createBlock(_unref(SignUpBonus), {
            key: 1
          })) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 2
          }, [((_activeType$value10 = activeType.value) === null || _activeType$value10 === void 0 ? void 0 : _activeType$value10.channel) === 'maya' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_withDirectives(_createVNode(_component_van_image, {
            class: "download-img",
            src: require('@/assets/img/finance/maya-app.png'),
            onClick: _cache[2] || (_cache[2] = $event => _unref(openBrowser)(MAYA_DOWNLOAD_URL))
          }, null, 8, ["src"]), [[_directive_audio]])])) : ((_activeType$value11 = activeType.value) === null || _activeType$value11 === void 0 ? void 0 : _activeType$value11.channel) === 'gcash' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_van_image, {
            class: "download-img",
            src: require('@/assets/img/finance/gcash-app.jpeg')
          }, null, 8, ["src"]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "action-btn",
            onClick: _cache[3] || (_cache[3] = $event => _unref(openBrowser)(GCASH_YOUTUBE))
          }, [_createTextVNode(_toDisplayString('Learn More'.toUpperCase()), 1)])), [[_directive_audio]])])])) : _createCommentVNode("", true), couponList.value && couponList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(couponList.value, item => {
            return _openBlock(), _createBlock(_unref(Coupon), {
              key: item.code,
              coupon: item,
              isActive: activeCoupon.value == item,
              onOnClick: $event => clickCoupon(item),
              onOnTimeUp: fetchCoupon
            }, null, 8, ["coupon", "isActive", "onOnClick"]);
          }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('label.amount')), 1), _createElementVNode("div", _hoisted_16, [_createVNode(_component_van_field, {
            modelValue: amount.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => amount.value = $event),
            class: "input-field",
            placeholder: _ctx.$t('placeholder.amount').format({
              min: ((_activeType$value12 = activeType.value) === null || _activeType$value12 === void 0 ? void 0 : _activeType$value12.lowLimit) || 100,
              max: ((_activeType$value13 = activeType.value) === null || _activeType$value13 === void 0 ? void 0 : _activeType$value13.upLimit) || 50000
            }),
            onInput: _cache[5] || (_cache[5] = $event => amount.value = _ctx.$filter.number($event.target.value)),
            onBlur: _cache[6] || (_cache[6] = $event => amount.value = _ctx.$filter.number($event.target.value)),
            type: "digit"
          }, null, 8, ["modelValue", "placeholder"]), !activeCoupon.value && (_activeAmount$value = activeAmount.value) !== null && _activeAmount$value !== void 0 && (_activeAmount$value = _activeAmount$value.reward) !== null && _activeAmount$value !== void 0 && _activeAmount$value.cashRewardFixed ? (_openBlock(), _createElementBlock("div", _hoisted_17, "+" + _toDisplayString((_activeAmount$value2 = activeAmount.value) === null || _activeAmount$value2 === void 0 || (_activeAmount$value2 = _activeAmount$value2.reward) === null || _activeAmount$value2 === void 0 ? void 0 : _activeAmount$value2.cashRewardFixed), 1)) : activeCoupon.value && depositReward.value ? (_openBlock(), _createElementBlock("div", _hoisted_18, "+" + _toDisplayString(depositReward.value), 1)) : _createCommentVNode("", true)]), _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "clear-btn flex justify-center",
            onClick: _cache[7] || (_cache[7] = $event => amount.value = '')
          }, [_createVNode(_component_van_image, {
            class: "clear-icon",
            src: require('@/assets/img/finance/clear.png')
          }, null, 8, ["src"])])), [[_directive_audio]])]), ((_activeType$value14 = activeType.value) === null || _activeType$value14 === void 0 ? void 0 : _activeType$value14.channel) === 'bank' ? (_openBlock(), _createElementBlock("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bankList.value, item => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["bank-item", {
                'active': activeBank.value === item
              }]),
              key: item.bank,
              onClick: $event => activeBank.value === item ? activeBank.value = null : activeBank.value = item
            }, [_createElementVNode("img", {
              class: "bank-img",
              src: item.icon
            }, null, 8, _hoisted_21)], 10, _hoisted_20)), [[_directive_audio]]);
          }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(priceList.value, item => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(`price-item ${activeAmount.value === item ? 'active' : ''}`),
              key: item.id,
              onClick: $event => amount.value = item.amount
            }, [_createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$filter.outputAmount(item.amount, 0)) + " PHP", 1), item.reward && !activeCoupon.value ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, "+" + _toDisplayString(item.reward.cashRewardFixed), 1)])) : _createCommentVNode("", true)], 10, _hoisted_23)), [[_directive_audio]]);
          }), 128))])), _withDirectives((_openBlock(), _createBlock(_component_van_button, {
            class: "confirm-button",
            disabled: confirmDisabled.value,
            onClick: doDeposit
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('common.confirm')), 1)]),
            _: 1
          }, 8, ["disabled"])), [[_directive_audio]])], 64))])])])];
        }),
        _: 1
      })], 512), showRecord.value ? (_openBlock(), _createBlock(_unref(Record), {
        key: 0,
        onOnClose: _cache[8] || (_cache[8] = $event => showRecord.value = false)
      })) : _createCommentVNode("", true)], 64);
    };
  }
};